import { cloneDeep } from 'lodash';
import { convertHeaderExcelFile, convertBodyExcelFile } from '../exportHelper';

const multiDataSetDefault = ({ t, title, columnsTable }) => convertHeaderExcelFile({ title, columnsTable, t });

const getSafeSheetName = (rawName, index) => {
  const fallbackName = `Sheet_${index + 1}`;
  const baseName = (rawName || fallbackName).toString();
  const sanitized = baseName.replace(/[\\/*?:[\]]/g, ' ').trim().slice(0, 31);
  return sanitized || fallbackName;
};

const buildDataSet = ({ data, t, title, columnsTable }) => {
  const newDataSheetSet = cloneDeep(
    multiDataSetDefault({
      t,
      title,
      columnsTable,
    })
  );
  const newListData =
    data && data.length
      ? data.map(item => {
          return convertBodyExcelFile({ item, columnsTable, t });
        })
      : [];
  if (newListData.length) {
    newDataSheetSet[1].data = newDataSheetSet[1].data.concat(newListData);
  }
  return newDataSheetSet;
};

const convertJson2Sheet = ({ data, t, title, columnsTable, rowsPerSheet, sheetNamePrefix, splitBySheet }) => {
  const listData = data && data.length ? data : [];
  const rowLimit = Number.isInteger(rowsPerSheet) && rowsPerSheet > 0 ? rowsPerSheet : null;
  const shouldSplit = Boolean(splitBySheet && rowLimit && listData.length > rowLimit);

  if (!shouldSplit) {
    return buildDataSet({
      data: listData,
      t,
      title,
      columnsTable,
    });
  }

  const totalSheets = Math.ceil(listData.length / rowLimit);
  const safePrefix = getSafeSheetName(sheetNamePrefix || title || 'Sheet', 0);
  const sheets = [];

  for (let index = 0; index < totalSheets; index++) {
    const start = index * rowLimit;
    const end = start + rowLimit;
    const chunk = listData.slice(start, end);
    sheets.push({
      name: getSafeSheetName(`${safePrefix}_${index + 1}`, index),
      dataSet: buildDataSet({
        data: chunk,
        t,
        title,
        columnsTable,
      }),
    });
  }

  return sheets;
};

export default convertJson2Sheet;
